import { render, staticRenderFns } from "./JFormContainer.vue?vue&type=template&id=6be379d6&"
import script from "./JFormContainer.vue?vue&type=script&lang=js&"
export * from "./JFormContainer.vue?vue&type=script&lang=js&"
import style0 from "./JFormContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports